


























































import {
  Component,
  Prop,
  mixins,
  Watch,
  namespace,
} from 'nuxt-property-decorator'
import 'swiper/swiper.scss'
import { Swiper, Navigation, Pagination } from 'swiper'
import { mdiChevronRight, mdiChevronLeft } from '@mdi/js'
import MixinGeneral from '~/assets/mixins/general'
import { ISliderSize } from '~/assets/interfaces/slider'
import { runIdle } from '~/assets/functions/runIndle'
let timer!: number
Swiper.use([Navigation, Pagination])

const siteStore = namespace('site')

@Component({
  components: {
    ComponentFormButtonIcon: () => import('~/components/form/button-icon.vue'),
  },
})
export default class ComponentSliderSwiper extends mixins(MixinGeneral) {
  @Prop({ type: Number }) readonly autoplayDelay!: number
  @Prop({ type: Boolean, default: false }) readonly pagination!: boolean
  @Prop({ type: Boolean, default: false }) readonly navigation!: boolean
  @Prop({ type: String, default: 'type-1' }) readonly type!: string
  @Prop({ type: Object }) readonly size!: ISliderSize

  @siteStore.Getter('getOptionsIsRunSliderImmediately')
  private isRunSliderImmediately!: boolean

  @Watch('type')
  private typeHandler() {
    setTimeout(() => {
      this.initSlider()
    })
  }

  private swiper!: Swiper
  private icons = {
    mdiChevronRight,
    mdiChevronLeft,
  }

  private isActive = false

  private get classType() {
    return {
      [this.$style.type1]: this.type === 'type-1',
      [this.$style.type2]: this.type === 'type-2',
    }
  }

  private get styleInner() {
    return {
      paddingTop: (this.size.height / this.size.width) * 100 + '%',
    }
  }

  private get styleInnerWrapper() {
    if (this.type === 'type-2') {
      if (this.$device.isMobileOrTablet) {
        return {
          width: 'calc((100% + 2 * (100% + 24px - 150px) - 24px) / 3)',
        }
      }
    }
    return {}
  }

  private mounted(): void {
    if (process.client) {
      if (this.isRunSliderImmediately) {
        runIdle(() => this.initSlider())
      } else {
        this.addListener()
      }
    }
    this.$emit('loaded')
    this.contentIsMounted = true
  }

  private addListener() {
    if (this.$device.isMobileOrTablet) {
      document.body.addEventListener('touchstart', this.initSlider)
    } else {
      document.body.addEventListener('mousemove', this.initSlider)
    }
  }

  private removeListener() {
    if (this.$device.isMobileOrTablet) {
      document.body.removeEventListener('touchstart', this.initSlider)
    } else {
      document.body.removeEventListener('mousemove', this.initSlider)
    }
  }

  private contentIsMounted = false

  private initSlider() {
    if (this.swiper) {
      this.swiper.destroy()
      this.stopAutoplay()
      this.isActive = false
    }
    const containerEl: HTMLElement = this.$refs.container as HTMLElement
    const paginationEl: HTMLElement = this.$refs.pagination as HTMLElement

    if (containerEl) {
      let options = {
        loop: true,
        touchMoveStopPropagation: true,
        spaceBetween: this.$device.isMobileOrTablet ? 12 : 24,
      }

      if (this.type === 'type-2') {
        options = Object.assign(options, {
          slidesPerView: 3,
        })
      }

      if (this.pagination && paginationEl) {
        options = Object.assign(options, {
          pagination: {
            el: paginationEl,
            renderBullet(_index: number, className: string) {
              return '<button class="' + className + '"></button>'
            },
            bulletClass: this.$style.paginationItem,
            bulletActiveClass: this.$style.active,
            clickable: true,
          },
        })
      }
      this.swiper = new Swiper(containerEl, options)
      this.startAutoplay()
      this.isActive = true
      this.$emit('loaded')

      if (!this.isRunSliderImmediately) {
        this.removeListener()
      }
    }
  }

  private slidePrev() {
    this.swiper.slidePrev()
  }

  private slideNext() {
    this.swiper.slideNext()
  }

  private stopAutoplay() {
    if (timer) {
      clearInterval(timer)
    }
  }

  private startAutoplay() {
    if (this.autoplayDelay) {
      timer = window.setInterval(() => {
        this.slideNext()
      }, this.autoplayDelay)
    }
  }

  private destroyed() {
    if (this.swiper) {
      this.swiper.destroy()
      this.stopAutoplay()
    }
  }
}
